<template>
  <el-upload :action="uploadUrl" :headers="headers" :file-list="files" :disabled="disabled" :before-upload="beforeUpload" :on-success="uploaded" :on-error="failed" :on-remove="removed" :on-exceed="exceeded" :limit="5" accept=".png,.jpg,.jpeg,.pdf" multiple>
    <el-button size="small" icon="el-icon-upload2" :disabled="disabled">上传处理附件</el-button>
    <span slot="tip" class="el-upload__tip">图片或 PDF，最多 5 份；提交前请等待上传完成。</span>
  </el-upload>
</template>

<script>
import { getToken } from '@/utils/auth'
import { uploadedIntentUrl } from '@/utils/intent-deposit'

export default {
  name: 'IntentDepositAttachments',
  props: { value: { type: Array, default: () => [] }, disabled: { type: Boolean, default: false } },
  data() { return { files: [], pending: [], uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload' } },
  computed: { headers() { return { Token: 'DU ' + getToken() } } },
  methods: {
    beforeUpload(file) {
      if (this.disabled) return false
      if (!/\.(png|jpe?g|pdf)$/i.test(file.name)) { this.$message.warning('请上传图片或 PDF'); return false }
      this.pending.push(file.uid); this.$emit('busy', true); return true
    },
    uploaded(res, file, files) {
      this.finishUpload(file)
      if (!res || String(res.code) !== '0' || !uploadedIntentUrl(res.data)) {
        this.files = files.filter(f => f.uid !== file.uid)
        this.$message.error((res && (res.message || res.msg)) || '附件上传失败，请重新上传')
        return
      }
      this.files = files.map(f => f.uid === file.uid ? { ...f, url: res.data } : f)
      this.emitUrls()
    },
    failed(error, file, files) {
      this.finishUpload(file); this.files = (files || []).filter(f => f.uid !== file.uid)
      this.$message.error('附件上传失败，请重新上传')
    },
    removed(file, files) { this.finishUpload(file); this.files = files; this.emitUrls() },
    exceeded() { this.$message.warning('最多上传 5 份处理附件') },
    finishUpload(file) { this.pending = this.pending.filter(uid => uid !== file.uid); this.$emit('busy', this.pending.length > 0) },
    emitUrls() { this.$emit('input', this.files.filter(f => uploadedIntentUrl(f.url)).map(f => f.url)) }
  }
}
</script>
